import {MenuItemSpec} from "./MenuItemSpec";
import React from "react";

export const MenuItemAction = (spec: MenuItemSpec): React.ReactNode => {
	const classBlock = 'dropdown';

	const label = typeof spec.label === 'string' ? spec.label : spec.label?.(spec);
	return (
		<button
			title={spec.tooltip}
			onClick={(e)=>spec.onClick?.(spec)}
			className={`${classBlock}__item-button`}
		>
			<div className={`${classBlock}__item-icon`}>{spec.icon}</div>
			<div className={`${classBlock}__item-button-label`}>
				{label}
			</div>
		</button>
	);
};